import { render } from "./LottoWrapperView.vue?vue&type=template&id=158007a2&ts=true"
import script from "./LottoWrapperView.vue?vue&type=script&lang=ts"
export * from "./LottoWrapperView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__